// Auth
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const LOAD_CURRENT_USER = "LOAD_CURRENT_USER";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAIL = "LOGOUT_FAIL";
export const USER_INITIATED_LOGOUT = "USER_INITIATED_LOGOUT";

// Flash
export const FLASH_SUCCESS = "FLASH_SUCCESS";
export const FLASH_INFO = "FLASH_INFO";
export const FLASH_WARNING = "FLASH_WARNING";
export const FLASH_ERROR = "FLASH_ERROR";
export const FLASH_OUT = "FLASH_OUT";
